var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@web/components/layout/Button';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { TableSortIcons } from '@web/components/layout/Table/TableSortIcons';
import { widgetMetricTableColMetricValueStyle, widgetMetricTableFigureValueSpanClass, widgetMetricTablePairHeaderThClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTablePeriodDiffRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { classNames, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { navigateToChartDestination } from '@web/utility/chartNavigation';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ApplicationEnum, SortOrderEnum } from '@workalizer/shared';
import { WIDGET_TABLE_INITIAL_ROWS, WIDGET_TABLE_LOAD_MORE_ROWS } from '@workalizer/shared/config';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
var topChattersValueDiffPair = [
    widgetMetricTableColMetricValueStyle,
    { width: '11%', minWidth: '5.125rem' }
];
var topChattersTableColgroup = __spreadArray(__spreadArray(__spreadArray([
    { width: '28%', minWidth: '11rem' }
], topChattersValueDiffPair, true), topChattersValueDiffPair, true), topChattersValueDiffPair, true);
var metricSortColumns = [
    {
        field: 'messagesSent',
        labelKey: 'app.apps.chat.topChatters.tablesData.messagesSent'
    },
    {
        field: 'avgResponseTimeSeconds',
        labelKey: 'app.apps.chat.topChatters.tablesData.avgResponseTime'
    },
    {
        field: 'messagesReceived',
        labelKey: 'app.apps.chat.topChatters.tablesData.messagesReceived'
    }
];
var metricColumnIndexByField = Object.fromEntries(metricSortColumns.map(function (column, index) { return [column.field, index + 1]; }));
var clickableMetricValueCell = function (id, value, onClick) { return ({
    id: id,
    className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
    render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: onClick }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: value })) }))); }
}); };
export function TopChatters() {
    var _this = this;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var filters = useFilters();
    var _a = useState(WIDGET_TABLE_INITIAL_ROWS), displayedCount = _a[0], setDisplayedCount = _a[1];
    var _b = useState({
        field: 'messagesSent',
        direction: SortOrderEnum.DESC
    }), sortBy = _b[0], setSortBy = _b[1];
    var _c = trpc.topChatters.useQuery({
        userId: filters.user,
        orgUnitId: filters.orgUnit,
        dateFrom: filters.dateFrom,
        dateTo: filters.dateTo,
        activityLabelId: filters.activityLabel
    }), topChattersData = _c.data, isLoading = _c.isLoading, refetch = _c.refetch;
    var navigateToChatEventsLog = function () {
        navigateToChartDestination({ kind: 'eventsLog', app: ApplicationEnum.CHAT }, {
            navigateTo: navigateTo,
            dateFrom: filters.dateFrom,
            dateTo: filters.dateTo,
            userId: filters.user,
            orgUnitId: filters.orgUnit
        });
    };
    if (isLoading) {
        return _jsx(Loading, {});
    }
    var sortDirection = sortBy.direction === SortOrderEnum.ASC ? 1 : -1;
    var sortedTopChattersData = __spreadArray([], (topChattersData !== null && topChattersData !== void 0 ? topChattersData : []), true).sort(function (a, b) { return sortDirection * (a[sortBy.field] - b[sortBy.field]); });
    var displayedTopChattersData = sortedTopChattersData.slice(0, displayedCount);
    var hasMore = sortedTopChattersData.length > displayedCount;
    var headerMetricClass = "".concat(widgetMetricTablePairHeaderThClass, " cursor-pointer");
    var columns = __spreadArray([
        {
            title: t('app.apps.chat.topChatters.tablesData.partner'),
            isVisible: true,
            className: 'min-w-0 !text-left'
        }
    ], metricSortColumns.map(function (_a) {
        var field = _a.field, labelKey = _a.labelKey;
        return ({
            title: (_jsxs("span", __assign({ className: "inline-flex items-center gap-1" }, { children: [t(labelKey), _jsx(TableSortIcons, { isActive: sortBy.field === field, direction: sortBy.direction })] }))),
            isVisible: true,
            colspan: 2,
            className: headerMetricClass,
            orderByField: field
        });
    }), true);
    var tableData = displayedTopChattersData.map(function (item) { return [
        {
            id: "partner-".concat(item.userId),
            className: classNames(widgetMetricTablePrimaryLabelTdClass, 'cursor-pointer'),
            render: function () { return (_jsxs("div", __assign({ className: "min-w-0 max-w-full cursor-pointer", onClick: navigateToChatEventsLog }, { children: [_jsx("div", __assign({ className: "font-semibold break-words" }, { children: item.userName })), item.department ? (_jsx("div", __assign({ className: "text-xs text-gray-500" }, { children: item.department }))) : null] }))); }
        },
        clickableMetricValueCell("messagesSent-value-".concat(item.userId), item.messagesSent, navigateToChatEventsLog),
        metricTablePeriodDiffRowCell("messagesSent-diff-".concat(item.userId), item.prevMessagesSent, TablesDiffColorsConfig.GREEN),
        clickableMetricValueCell("avgResponseTime-value-".concat(item.userId), item.avgResponseTime, navigateToChatEventsLog),
        metricTablePeriodDiffRowCell("avgResponseTime-diff-".concat(item.userId), item.prevAvgResponseTime, TablesDiffColorsConfig.GREEN),
        clickableMetricValueCell("messagesReceived-value-".concat(item.userId), item.messagesReceived, navigateToChatEventsLog),
        metricTablePeriodDiffRowCell("messagesReceived-diff-".concat(item.userId), item.prevMessagesReceived, TablesDiffColorsConfig.GREEN)
    ]; });
    var titleKey = 'app.apps.chat.topChatters.title';
    var descriptionKey = 'widgetTitleDescriptions.apps.topChatters';
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t(titleKey), description: descriptionKey, insightType: InsightTypeEnum.topChatters, insightsData: displayedTopChattersData, refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t(titleKey), onExportHandler: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, displayedTopChattersData.map(function (item) {
                                    var _a;
                                    return (_a = {},
                                        _a[t('app.apps.chat.topChatters.tablesData.partner')] = item.department
                                            ? "".concat(item.userName, " (").concat(item.department, ")")
                                            : item.userName,
                                        _a[t('app.apps.chat.topChatters.tablesData.messagesSent')] = item.messagesSent,
                                        _a[t('app.apps.chat.topChatters.tablesData.avgResponseTime')] = item.avgResponseTime,
                                        _a[t('app.apps.chat.topChatters.tablesData.messagesReceived')] = item.messagesReceived,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(displayedTopChattersData) }) }), _jsx(Table, { columns: columns, data: isInsightsDataEmpty(displayedTopChattersData) ? [] : tableData, columnColStyles: topChattersTableColgroup, tableClassName: "table-auto w-full", rowClassName: "[&>td]:align-top", sortingOption: {
                    show: true,
                    elementIndex: metricColumnIndexByField[sortBy.field],
                    orderByField: sortBy.field,
                    direction: sortBy.direction,
                    orderByDirection: sortBy.direction
                }, setSortingOption: function (_a) {
                    var orderByField = _a.orderByField, direction = _a.direction;
                    return setSortBy({
                        field: orderByField,
                        direction: direction
                    });
                } }), hasMore && (_jsx("div", __assign({ className: "mt-4 flex justify-center" }, { children: _jsx(Button, __assign({ variant: "link", onClick: function () {
                        return setDisplayedCount(function (prev) { return prev + WIDGET_TABLE_LOAD_MORE_ROWS; });
                    } }, { children: t('loadMore') })) })))] })));
}
